import React, {useState} from 'react';
import {NavLink, Route, Routes} from "react-router-dom";
import Iqtisodiyot from './iqtisodiyot/index'
import Jami from './jami/index'
import ContentTop from "../../../components/ContentTop";
function Index(props) {
    const [menu, setMenu] = useState(1)
    return (
        <>
            <ContentTop>
            <ul className="content-top-left in-menu">
                <li>PTN</li>
                <li className={menu==1?'active':''}>
                    <NavLink to="/limit/manbalar/iqtisodiyot" onClick={()=>setMenu(1)}>iqtisodiyot</NavLink>
                </li>
                <li className={menu==2?'active':''}>
                    <NavLink to="/limit/manbalar/jami" onClick={()=>setMenu(2)}>Jami</NavLink>
                </li>
            </ul>
            </ContentTop>
            <div className="tabs-content table-box">
                <div className="tabs-content-item active">
                    <Routes>
                        <Route path="/*" element={
                            <Iqtisodiyot />
                        }/>
                        <Route path="/jami/*" element={
                            <Jami />
                        }/>
                        <Route path="/iqtisodiyot/*" element={
                            <Iqtisodiyot />
                        }/>
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default Index;